import { render } from "./RecommandItem.vue?vue&type=template&id=2707265c&scoped=true"
import script from "./RecommandItem.vue?vue&type=script&lang=js"
export * from "./RecommandItem.vue?vue&type=script&lang=js"

import "./RecommandItem.vue?vue&type=style&index=0&id=2707265c&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2707265c"]])

export default __exports__